import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "@/components/PasswordInput";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      applyAuth(data);
      toast.success("Password aggiornata! Sei dentro.");
      navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFBFA] p-6">
      <div className="w-full max-w-sm mo-fade-up" data-testid="reset-password-page">
        <div className="mb-8"><Link to="/"><Logo /></Link></div>
        {!token ? (
          <div className="rounded-2xl mo-card p-6" data-testid="reset-missing-token">
            <h1 className="font-display font-bold text-2xl mb-2">Link non valido</h1>
            <p className="text-gray-600 text-sm mb-4">Il link che hai aperto è incompleto. Richiedi un nuovo link di recupero.</p>
            <Link to="/forgot-password" className="text-[#5aa469] font-medium hover:underline text-sm">Richiedi nuovo link</Link>
          </div>
        ) : (
          <>
            <h1 className="font-display font-bold text-4xl mb-2">Nuova password</h1>
            <p className="text-gray-500 mb-8">Scegli la nuova password per il tuo account MenuOne.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="password">Nuova password</Label>
                <PasswordInput id="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11 rounded-lg focus:border-[#5aa469]" placeholder="Almeno 6 caratteri" data-testid="reset-password" />
              </div>
              <div>
                <Label htmlFor="confirm">Conferma password</Label>
                <PasswordInput id="confirm" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11 rounded-lg focus:border-[#5aa469]" placeholder="Ripeti la password" data-testid="reset-confirm" />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-full bg-[#5aa469] hover:bg-[#4a8a56] text-white font-semibold active:scale-95 transition-transform" data-testid="reset-submit">
                {loading ? "Salvataggio…" : "Salva nuova password"}
              </Button>
            </form>
            <p className="text-sm text-gray-500 mt-6 text-center">
              <Link to="/login" className="text-[#5aa469] font-medium hover:underline">Torna al login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
